module.exports = __webpack_public_path__ + "static/img/on6.6359a2fa.png";